import { useState } from 'react';

export interface UpdateModelPayload {
  model_name: string;
  deployment?: string;
  sdk_type?: string;
  max_tokens?: number;
  cost_prompt?: number;
  cost_completion?: number;
  is_active?: number;
  description?: string;
}

const useUpdateModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const API_URL = process.env.REACT_APP_UPDATE_MODEL_API || '';

  const updateModel = async (payload: UpdateModelPayload): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const text = await response.text();
        setError(text || `Request failed with status ${response.status}`);
        return false;
      }
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to update model';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updateModel, loading, error };
};

export default useUpdateModel;
